import { render } from "./TeamCard.vue?vue&type=template&id=5276b5b4&scoped=true"
import script from "./TeamCard.vue?vue&type=script&lang=js"
export * from "./TeamCard.vue?vue&type=script&lang=js"

import "./TeamCard.vue?vue&type=style&index=0&id=5276b5b4&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5276b5b4"]])

export default __exports__